module.exports = __webpack_public_path__ + "img/check-mark.d014b6a4.svg";